// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
// Migration vers le nouveau systeme de cles Supabase (sb_publishable_*).
// VITE_SUPABASE_ANON_KEY (ancien JWT anon) reste tolere temporairement en fallback
// pendant la phase de validation - a supprimer une fois la prod basculee.
const SUPABASE_PUBLISHABLE_KEY =
  import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY ??
  import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!SUPABASE_URL || !SUPABASE_PUBLISHABLE_KEY) {
  throw new Error(
    "[Systeme1] Variables d'environnement manquantes : VITE_SUPABASE_URL et/ou VITE_SUPABASE_PUBLISHABLE_KEY. Configurez-les dans Vercel → Settings → Environment Variables."
  );
}

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});